/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RetryScheduleRequestBody,
  RetryScheduleRequestBody$Outbound,
  RetryScheduleRequestBody$outboundSchema,
} from "../components/retryschedulerequestbody.js";

export type RetryAIIntegrationScheduleSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type RetryAIIntegrationScheduleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  retryScheduleRequestBody: RetryScheduleRequestBody;
};

/** @internal */
export type RetryAIIntegrationScheduleSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RetryAIIntegrationScheduleSecurity$outboundSchema: z.ZodMiniType<
  RetryAIIntegrationScheduleSecurity$Outbound,
  RetryAIIntegrationScheduleSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function retryAIIntegrationScheduleSecurityToJSON(
  retryAIIntegrationScheduleSecurity: RetryAIIntegrationScheduleSecurity,
): string {
  return JSON.stringify(
    RetryAIIntegrationScheduleSecurity$outboundSchema.parse(
      retryAIIntegrationScheduleSecurity,
    ),
  );
}

/** @internal */
export type RetryAIIntegrationScheduleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  RetryScheduleRequestBody: RetryScheduleRequestBody$Outbound;
};

/** @internal */
export const RetryAIIntegrationScheduleRequest$outboundSchema: z.ZodMiniType<
  RetryAIIntegrationScheduleRequest$Outbound,
  RetryAIIntegrationScheduleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    retryScheduleRequestBody: RetryScheduleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      retryScheduleRequestBody: "RetryScheduleRequestBody",
    });
  }),
);

export function retryAIIntegrationScheduleRequestToJSON(
  retryAIIntegrationScheduleRequest: RetryAIIntegrationScheduleRequest,
): string {
  return JSON.stringify(
    RetryAIIntegrationScheduleRequest$outboundSchema.parse(
      retryAIIntegrationScheduleRequest,
    ),
  );
}
